// Domain types for Onboarding 2.0 feature
// Maps to GraphQL types from creator-api/src/onboarding-2.0/onboarding-two.contract.gql

export type OnboardingQuestionType =
  | 'SINGLE_CHOICE'
  | 'MULTI_CHOICE'
  | 'OPEN_TEXT';

export type OnboardingAnswer = {
  id: string;
  title: string;
  subtitle: string | null;
  weight: number; // Default 1 if not provided from API
  chartValue: number; // Normalized 1-4 scale for chart rendering
};

export type OnboardingQuestion = {
  id: string;
  title: string;
  subtitle: string | null;
  type: OnboardingQuestionType;
  targetCategory: string | null; // Maps to radar chart axis (nullable)
  isRequired: boolean;
  answers: OnboardingAnswer[];
};

export type OnboardingResponse = {
  questionId: string;
  answerIds: string[]; // Selected answer ids. Empty for OPEN_TEXT; one for SINGLE_CHOICE; one-or-more for MULTI_CHOICE.
  textValue: string | null;
};

export type ScoringCategory = {
  id: string;
  name: string; // Experience, Audience, Time, Goal, Help
};

export type ScoringRule = {
  id: string;
  strategyId: string;
  categoryId: string;
  minScore: number;
  maxScore: number;
};

export type CaseStudy = {
  id: string;
  strategyId: string;
  title: string;
  subtitle: string | null;
  description: string | null;
  coverImageHorizontalUrl: string;
  coverImageVerticalUrl: string;
  creatorName: string;
  creatorInstagramName: string;
  documentUrl: string;
};

export type Strategy = {
  id: string;
  name: string;
  tagline: string | null;
  description: string | null;
  superTitle: string | null;
  pills: string[];
  features: string[];
  priceLabel: string | null;
  programLengthLabel: string | null;
  launchTimeLabel: string | null;
  coverImageUrl: string | null;
  isRecommended: boolean;
  isActive: boolean;
  isSelected: boolean;
  caseStudies: CaseStudy[];
};

export type OnboardingDismissal = {
  webDismissedAt: string | null;
  mobileDismissedAt: string | null;
};

// Booking-step classification driving the post-strategy route. `pending`
// means social enrichment hasn't resolved yet — the verdict isn't known, so
// the flow should wait and re-check rather than assume ineligible.
export type BookingEligibility = 'pending' | 'eligible' | 'not-eligible';

// Onboarding launch date - users published before this date never see onboarding
export const ONBOARDING_LAUNCH_DATE = new Date('2026-02-17T00:00:00Z');
